import React, { Component } from "react";
import * as API from "../../api.js";
import Loader from "../../icons/loader.svg";
import { ActivityPopup } from "../../ReusableComponents/ActivityPopup.js";
import AppConstants, { BLOB_URL } from "../../AppConstants";
import { PICSTORK_FEATURES } from "../../Teams";
import ButtonWithIcon from "../../ReusableComponents/ButtonWithIcon";
import DropDownWithButton from "../../ReusableComponents/DropDownWithButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { downloadReport } from "../../utils.js";
import { Modal } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";

class TowerDetailedReport extends Component {
  state = {
    showRegeneratePopup: false,
    reportPollInterval: null,
    isThermalTask: undefined,
    user: {},
    type: "",
    progress: 0,
    selectedObj: [],
    outId: "",
    objectsDetected: 0,
    showDownloadPopup: false,
    loader: true,
    services: [],
    isDetectionDirty: false,
    task: [],
    obj: [],
    report: [],
    objects: [],
    allImages: [], // All images from image_data
    projects: [],
    showBackIcon: true,
    cancel: false,
    loading: true,
    showAllImages: false,
    sidebarMode: this.props ? this.props.sidebarMode : "shrunk",
    selectAll: true,
    initialized: false,
    itemName: "",
    showProcessPopup: false,
    processPopupIcon: "",
    processAction: "",
    processMessage: "",
    selectedSeverityName: "All",
    selectedSeverity: undefined,
    isTiff: false,
    callCount: 0,
    analisedImages: 0,
    inspectionReport: null,
  };

  fetchThermalMeta = async (report) => {
    await API.getThermalMeta(
      this.props.permissions?.container,
      this.props.permissions?.st,
      this.state.task.image_collection_id,
      report.image
    )
      .then((res) => {
        this.setState(
          (state) => ({
            ...state,
            isThermalTask: res.ImageInfo ? true : false,
            loading: false,
          }),
          () => {}
        );
      })
      .catch((err) => console.log(err));
  };

  checkIsTiffavailable = () => {
    if (
      this.state.report?.[0]?.image.toLowerCase().includes("tif") ||
      this.state.report?.[0]?.image.toLowerCase().includes("tiff")
    ) {
      this.setState((state) => ({
        ...state,
        isTiff: true,
      }));
    } else {
      this.fetchThermalMeta(this.state.report[0]);
    }
    this.setState({
      loading: false,
      imageListLoading: false,
    });
  };

  parentSidebarSwitch = () => {
    this.setState((state) => ({
      ...state,
      sidebarMode: state.sidebarMode == "shrunk" ? "expanded" : "shrunk",
    }));
  };

  getTask = async () => {
    await API.getAeroCaptureTask(this.state.task.task_id).then(
      (data) => {
        this.setState((state) => ({
          ...state,
          task: data,
        }));
      },
      (e) => {
        console.log(e);
      }
    );
  };

  getReportDetails = async () => {
    let objects = [];
    let sel = [];
    this.setState((prevState) => ({
      ...prevState,
      callCount: prevState.callCount + 1,
    }));

    this.state.obj.map((el) => {
      if (el.selected === true && el.type) {
        objects.push(el.type);
      }
      if (el.type) sel.push(el.type);
    });

    this.setState((state) => ({
      ...state,
      selectAll:
        this.state.initialized && objects.length != sel.length ? false : true,
      selectedObj: objects,
      initialized: true,
    }));

    await API.getDetections(this.state.task.task_id, objects).then(
      (data) => {
        // Create a map of image names to their detection data for easy lookup
        const detectionMap = {};
        if (data.ret && data.ret.length > 0) {
          data.ret.forEach((detection) => {
            detectionMap[detection.image] = detection;
          });
        }

        // Get all unique images from image_data (filter out the summary object)
        const allImages = data.image_data.filter(
          (img) => img.file_name && typeof img === "object"
        );

        // Combine all images with their detection data (if any)
        const combinedReport = allImages.map((image) => {
          const detection = detectionMap[image.file_name] || {};
          let objectsDetected = 0;

          // Calculate objects detected count
          if (detection.result && detection.result.detections) {
            Object.values(detection.result.detections).forEach(
              (detectionObj) => {
                objectsDetected += detectionObj.data
                  ? detectionObj.data.length
                  : 0;
              }
            );
          }

          return {
            image: image.file_name,
            result: detection.result || { detections: {} },
            objectsDetected: objectsDetected,
            imageData: image, // Store the full image data
          };
        });

        if (combinedReport.length > 0) {
          this.setState(
            (state) => ({
              ...state,
              report: combinedReport,
              allImages: allImages,
              isDetectionDirty: true,
            }),
            () => {
              let counter = 0;
              let temp1 = [];
              let objectsDetected = 0;
              let types =
                !this.state.selectAll || objects.length > 0
                  ? objects
                  : this.state.task.type;

              this.state.report.forEach((el) => {
                let severityMatched = false;

                // Update object counts
                if (this.state.callCount === 1) {
                  let tempObjArr = [...this.state.obj];
                  for (let i = 0; i < tempObjArr.length; i++) {
                    const cls = tempObjArr[i];
                    if (el.result.detections?.[cls.type]) {
                      tempObjArr[i].count =
                        (tempObjArr[i].count || 0) +
                        el.result.detections[cls.type].count;
                    }
                  }
                  this.setState((state) => ({
                    ...state,
                    obj: tempObjArr,
                  }));
                }

                let cnt = 0;
                types.forEach((type) => {
                  if (el.result.detections && el.result.detections[type]) {
                    if (
                      el.result.detections[type].data.length === 0 &&
                      this.state.selectedSeverity === undefined
                    ) {
                      severityMatched = true;
                    }
                    el.result.detections[type].data.forEach((dt) => {
                      if (
                        this.state.selectedSeverity === undefined ||
                        dt?.severity == this.state.selectedSeverity ||
                        dt?.data?.severity == this.state.selectedSeverity
                      ) {
                        cnt += 1;
                        objectsDetected += 1;
                        severityMatched = true;
                      }
                    });
                  }
                });

                if (severityMatched || this.state.showAllImages) {
                  temp1.push(el);
                }
                el.objectsDetected = cnt;
                counter++;

                if (counter == this.state.report.length) {
                  let showAllImages =
                    this.state.selectAll ||
                    (objectsDetected == 0 && !this.state.selectAll);
                  this.setState(
                    (state) => ({
                      ...state,
                      objectsDetected: objectsDetected,
                      showAllImages,
                      report: temp1,
                      loading: true,
                    }),
                    () => {
                      if (this.state.report.length > 0)
                        this.checkIsTiffavailable();
                      else {
                        this.setState({
                          loading: false,
                          imageListLoading: false,
                        });
                      }
                    }
                  );
                }
              });
            }
          );
        } else {
          let showAllImages = this.state.task.tasktype == 4;
          this.setState((state) => ({
            ...state,
            loading: false,
            imageListLoading: false,
            objectsDetected: 0,
            showAllImages,
            report: [],
          }));
        }
      },
      (e) => {
        console.log(e);
        this.setState((state) => ({
          ...state,
          report: [],
          loading: false,
          imageListLoading: false,
        }));
      }
    );
  };

  //Export Zip
  exportData = () => {
    API.exportDetectionZip(this.state.task.task_id)
      .then((res) => {
        res
          .blob()
          .then((blob) => window.URL.createObjectURL(blob))
          .then((uril) => {
            var link = document.createElement("a");
            link.href = uril;
            link.download = `${this.state.task.task_id}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.setState((state) => ({
              ...state,
              savingLoader: false,
            }));
          });
      })
      .catch((e) => {
        console.log(e.message);
        this.setState((state) => ({
          ...state,
          itemName: "Annotationset",
          processPopupIcon: "ERROR",
          processAction: "ADD",
          processMessage: e.message,
          showProcessPopup: true,
        }));
      });
  };

  closeActivityPopup = () => {
    this.setState((state) => ({
      ...state,
      showProcessPopup: false,
      processMessage: null,
    }));
  };

  //toggle select
  toggleSelecetAll = () => {
    let objects = [];
    this.state.obj.map((el, i) => {
      if (this.state.selectAll) {
        el.selected = true;
        objects.push(el);
      } else {
        el.selected = false;
        objects.push(el);
      }
    });
    this.setState(
      (state) => ({
        ...state,
        obj: objects,
      }),
      () => {
        this.getReportDetails();
      }
    );
  };

  componentWillMount() {
    document.title = "PicStork - Detailed Report";
    if (this.state.reportPollInterval) {
      clearInterval(this.state.reportPollInterval);
      this.state.reportPollInterval = null;
    }
    if (this.props) {
      let { user, type, task, plan, project } = this.props;
      this.setState(
        (state) => ({
          ...state,
          user,
          type,
          task,
          plan,
          project,
          objects: task && task.type && task.type.length ? task.type : [],
        }),
        async () => {
          await this.getTask();

          if (this.state.task && this.state.task.type) {
            let ob = this.state.task.type;
            var temp = { selected: false, type: "", id: 0 };
            var tmp = [];
            ob.forEach((type, key) => {
              temp.selected = true;
              temp.type = type;
              temp.id = key;
              tmp.push(temp);
              temp = {};
            });
            tmp.push({});
            this.setState((state) => ({
              ...state,
              obj: tmp,
            }));
          }

          await this.getReportDetails();

          let img = this.state?.report?.map((img) => {
            if (img.objectsDetected != 0) {
              this.setState({ analisedImages: this.state.analisedImages + 1 });
            }
          });

          if (this.state.plan?.collection_id) {
            await this.getInspectionReportDetails(
              this.state.task?.image_collection_id
            );
          }

          API.getUserSubbedServices().then((response) => {
            let services = response[0];
            if (services.length == 1 && services[0].title == "AeroStream") {
              this.setState((state) => ({
                ...state,
                showBackIcon: false,
              }));
            } else {
              this.setState((state) => ({
                ...state,
                showBackIcon: true,
              }));
            }
          });
        }
      );
    } else {
      API.getUserType().then(
        ([blah, type, user]) => {
          this.setState(
            (state) => ({
              ...state,
              user,
              type,
            }),
            () => {
              this.getReportDetails();
            }
          );
        },
        (e) => {
          window.location.replace("/login");
        }
      );
    }
  }

  handleRegenerateReport = async (status) => {
    if (!this.state.inspectionReport?.id) return;

    try {
      const response = await API.updateReportStatus({
        reportId: this.state.inspectionReport?.id,
        status: status || "Pending",
        report_type: "Tower_Inspection",
      });
      if (response?.report) {
        toast.success(
          "Report regeneration started! Please wait a few seconds..."
        );
      }

      if (response.error) {
        toast.error("Report regeneration failed! Please try again...");
        return;
      }
      this.pollReportStatus();
    } catch (err) {
      console.error("Error while regenerating report:", err);
    }
  };

  getInspectionReportDetails = async (collectionId) => {
    try {
      const data = await API.getTowerInspectionReportDetails(collectionId);

      if (data.error) {
        console.error("Error fetching inspection report:", data.error);
        this.setState({ loading: false });
        return;
      }

      this.setState({
        inspectionReport: data,
      });
      return data;
    } catch (error) {
      console.error("Error fetching inspection report details:", error);
    }
  };

  handleGenerateReport = async () => {
    try {
      const response = await API.createReport({
        type: "Tower_Inspection",
        project_id: this.props.project?.id,
        plan_id: this.props.plan?.id,
        image_collection_id: this.state.task?.image_collection_id,
        status: "Pending",
      });
      if (response?.report) {
        toast.success(
          "Report generation started! Please wait a few seconds..."
        );
      }

      if (response.error) {
        toast.error("Report generation failed! Please try again...");
        return;
      }
      this.pollReportStatus();
    } catch (err) {
      console.error("Unexpected error:", err);
    }
  };

  getButtonStates = (status, url) => {
    switch (status) {
      case "Pending":
      case "In_Progress":
        return { download: true, regenerate: true };
      case "Completed":
        return { download: false, regenerate: true };
      case "Regenerate":
        return { download: url ? false : true, regenerate: false };
      case "Failed":
        return { download: true, regenerate: false };
      default:
        return { download: true, regenerate: true };
    }
  };

  pollReportStatus = () => {
    if (this.state.reportPollInterval) {
      clearInterval(this.state.reportPollInterval);
    }

    this.state.reportPollInterval = setInterval(async () => {
      try {
        const data = await this.getInspectionReportDetails(
          this.state.task?.image_collection_id
        );

        if (data) {
          this.setState({ inspectionReport: data });

          if (
            data.status === "Completed" ||
            data.status === "Failed" ||
            data.status === "Regenerate"
          ) {
            clearInterval(this.state.reportPollInterval);
            this.state.reportPollInterval = null;
            console.log("Polling stopped. Report status:", data.status);
          }
        }

        if (data?.status === "Failed") {
          toast.error("Report generation failed!");
        }
      } catch (err) {
        console.error("Error while polling report status:", err);
        clearInterval(this.state.reportPollInterval);
        this.state.reportPollInterval = null;
      }
    }, 3000);
  };

  render() {
    const label =
      this.state.inspectionReport?.status === "Pending" ||
      this.state.inspectionReport?.status === "In_Progress"
        ? "Generating Report..."
        : "Download Report";

    const { download, regenerate } = this.getButtonStates(
      this.state.inspectionReport?.status,
      this.state.inspectionReport?.report_url
    );

    const removePadding = {
      padding: "0px",
    };

    let {
      user,
      type,
      projects,
      sidebarMode,
      showBackIcon,
      task,
      report,
      plan,
      project,
    } = this.state;

    return user.username ? (
      <div className="wrapper" style={{ width: "100%" }}>
        <Toaster
          position="top-right"
          reverseOrder={false}
          toastOptions={{
            duration: 3000,
            style: {
              fontSize: "12px",
              marginTop: "35px",
            },
          }}
        />
        <ActivityPopup
          item={this.state.itemName}
          open={this.state.showProcessPopup}
          icon={this.state.processPopupIcon}
          action={this.state.processAction}
          msg={this.state.processMessage}
          close={() => this.closeActivityPopup()}
          onClickOk={() => {
            this.closeActivityPopup();
          }}
        ></ActivityPopup>

        <div style={{ width: "100%" }}>
          {this.state.loading ? (
            <div
              style={{
                height: "85vh",
                width: "100%",
                display: "flex",
                textAlign: "center",
              }}
            >
              <img
                src={Loader}
                style={{ height: "30vh", width: "100%", margin: "auto" }}
              />
            </div>
          ) : (
            <div
              style={{ background: "none", width: "100%", margin: "1% 0%" }}
              onClick={() => {
                this.setState((state) => ({
                  ...state,
                  sidebarMode: "shrunk",
                }));
              }}
            >
              {/*Search Filter Result in Number */}
              {true ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontSize: "14px",
                    margin: "10px 0 5px 0",
                    width: "930px",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div style={{ color: "#2989CF" }}>
                      <button
                        onClick={() => {
                          this.props.changeView(1);
                          this.setState({ inspectionReport: null });
                        }}
                      >
                        <KeyboardBackspaceIcon />
                      </button>
                    </div>

                    <div style={{ removePadding }}>
                      <div style={{ color: "#2989CF" }}>
                        <b>Objects Detected</b>
                      </div>
                      <div>
                        <b>{this.state.objectsDetected}</b>
                      </div>
                    </div>

                    {!this.state.isTiff && (
                      <div style={{ removePadding }}>
                        <div style={{ color: "#2989CF" }}>
                          <b>Images Analyzed</b>
                        </div>
                        <div>
                          <b>{this.state.analisedImages}</b>
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "7px",
                    }}
                  >
                    {this.state.inspectionReport?.data === null ? (
                      <ButtonWithIcon
                        text="Generate Report"
                        onClick={this.handleGenerateReport}
                        isDisabled={false}
                      />
                    ) : (
                      <>
                        <ButtonWithIcon
                          text={label || "Download Report"}
                          onClick={() =>
                            downloadReport(
                              this.state.inspectionReport?.report_url,
                              `${this.props?.plan?.plan_name}InspectionReport.pdf`
                            )
                          }
                          isDisabled={download}
                        />
                        <ButtonWithIcon
                          text="Regenerate Report"
                          onClick={() => {
                            if (
                              this.state.inspectionReport?.status === "Failed"
                            ) {
                              this.setState({ showRegeneratePopup: false });
                              this.handleRegenerateReport("Pending");
                            } else if (
                              this.state.inspectionReport?.report_url
                            ) {
                              this.setState({ showRegeneratePopup: true });
                            } else {
                              this.handleRegenerateReport("Pending");
                            }
                          }}
                          isDisabled={regenerate}
                        />
                      </>
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {this.state.imageListLoading ? (
                <div
                  style={{
                    height: "65vh",
                    width: "100%",
                    display: "flex",
                    textAlign: "center",
                  }}
                >
                  <img
                    src={Loader}
                    style={{ height: "200px", width: "100%", margin: "auto" }}
                  />
                </div>
              ) : report.length ? (
                <div style={{ height: "56vh", overflow: "auto" }}>
                  <div
                    className="aerocapture-cards-tray-projects"
                    style={{
                      justifyContent: "left",
                      gridGap: "30px",
                      columnGap: "30px",
                    }}
                  >
                    {report.map((report, key) => {
                      return (
                        <div
                          onClick={() =>
                            this.props.changeView(3, {
                              user,
                              type: this.state.selectedObj,
                              task,
                              report: this.state.report,
                              key: key,
                              selectedImage: report.image,
                              selectedSeverity: this.state.selectedSeverity,
                              plan,
                              project,
                              showAllImages: this.state.showAllImages,
                            })
                          }
                        >
                          {
                            <div
                              key={key}
                              className="customer-cards-dashboard card"
                              style={{
                                cursor: "pointer",
                                boxShadow: "0px 6px 10px rgb(0 0 0 / 30%)",
                                border:
                                  report.objectsDetected > 0
                                    ? "2px solid #2989CF"
                                    : "1px solid #ddd",
                              }}
                            >
                              <div className="card-header customer-cards-dashboard-logo project-card-header">
                                <img
                                  id="ProjectImageFarm"
                                  style={{
                                    objectFit: "cover",
                                    height: "108px",
                                  }}
                                  src={`${BLOB_URL}/${this.props.permissions?.container}/FlightImages/collection-${task.image_collection_id}/thumb-${report.image}?${this.props.permissions?.st}`}
                                  onError={(e) => {
                                    // Fallback if thumb doesn't exist
                                    e.target.src = `${BLOB_URL}/${this.props.permissions?.container}/FlightImages/collection-${task.image_collection_id}/${report.image}?${this.props.permissions?.st}`;
                                  }}
                                />
                              </div>
                              <div
                                className="customer-cards-dashboard-text"
                                style={{
                                  marginTop: "15px",
                                  padding: "3px 5px",
                                  backgroundColor:
                                    report.objectsDetected > 0
                                      ? "rgba(41, 137, 207, 0.8)"
                                      : "rgba(0,0,0,.5)",
                                  color: "white",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  style={{
                                    height: "24px",
                                    overflow: "hidden",
                                    fontSize: "11px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  {report.image.length > 12
                                    ? `${report.image.substring(0, 11)}...`
                                    : `${report.image}`}
                                </div>
                                {report.objectsDetected > 0 && (
                                  <div
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      borderRadius: "50%",
                                      backgroundColor: "white",
                                      color: "#666666",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "11px",
                                    }}
                                  >{`${report.objectsDetected}`}</div>
                                )}
                              </div>
                            </div>
                          }
                        </div>
                      );
                    })}
                  </div>

                  <Modal
                    style={{ marginTop: "150px" }}
                    show={this.state.showRegeneratePopup}
                    onHide={() => this.setState({ showRegeneratePopup: false })}
                  >
                    <Modal.Body>
                      <p>
                        Previous version of the report will be lost by
                        regenerating. Please download it if needed.
                      </p>
                    </Modal.Body>
                    <Modal.Footer>
                      <button
                        className="addcustomer-button-empty-dashboard"
                        onClick={() =>
                          this.setState({ showRegeneratePopup: false })
                        }
                      >
                        Cancel
                      </button>
                      <button
                        className="add-user-form-submit-button btn-ok"
                        onClick={() => {
                          this.handleRegenerateReport("Pending");
                          this.setState({ showRegeneratePopup: false });
                        }}
                      >
                        Regenerate
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
              ) : (
                <div className="rmp-dashboard-empty-data-message">
                  No images available
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    ) : (
      <div />
    );
  }
}

export default TowerDetailedReport;
